import { render, staticRenderFns } from "./set-gateway.vue?vue&type=template&id=1d700c66&scoped=true&"
import script from "./set-gateway.vue?vue&type=script&lang=js&"
export * from "./set-gateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d700c66",
  null
  
)

export default component.exports